export interface IIpConfig {
    branch_IP_ID?: number,
    company_ID?: number,
    branch_ID?: number,
    branchName?: string,
    branch_IP?: string
}

export const EmptyIpConfig: IIpConfig = {
    branch_IP_ID: undefined,
    company_ID: 0,
    branch_ID: 0,
    branch_IP: ""
}